module.exports = __webpack_public_path__ + "img/norecord.e55f1abd.png";